import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import planer from 'planer';
import MsgAvatar from '../messaging-avatar';
import ActionDialog from './dialog/actionDialog';
import Attachments from './regularAttachments';
import MessageWrapper from './message-wrapper';
import {
  updateProps as updatePropsAction,
} from '../messagingStore/messaging-actions';
import R from 'ramda';

const propTypes = {
  messages: PropTypes.array,
  loadingMessages: PropTypes.bool,
  conv: PropTypes.object,
  params: PropTypes.object,
  viewerCompany: PropTypes.object,
  updateProps: PropTypes.func,
};

class Messages extends React.Component {

  componentDidMount() {
    // const hash = `#bottomEl`;
    // const element = document.querySelector(hash);
    // if (element) scrollTo(hash);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { messages } = this.props;
    return (
      <div style={{ padding: '16px 32px' }}>
        {
          messages.map((msg) => {
            return (
              <MessageWrapper
                key={msg.messageId}
                id={msg.messageId}
                avatarInfo={msg.creatorMeta}
                timestamp={msg.updatedAt}
                isSender={msg.viewerIsSender}
              >
                <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px' }}>{msg.subject}</div>
                <div
                  className="message-div"
                  style={{ display: msg.bodyText ? 'block' : 'none', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                  dangerouslySetInnerHTML={{ __html: msg.bodyJson.emailBody.html ? msg.bodyJson.emailBody.html : msg.bodyText }}
                />
                <Attachments
                  uploads={msg.attachments}
                  allowFilesToBeAddedToContract
                  addToContractFn={(files) => this.props.updateProps('action_dialog', {
                    open: true,
                    type: 'addToContract',
                    files: R.map(R.merge({ source: 'emailScrape' }), files),
                    msg,
                    supplierInfo: {},
                  })}
                />
              </MessageWrapper>
            );
          })
        }
        <div id="bottomEl"/>
        <ActionDialog updateProps={this.props.updateProps} />
      </div>
      );
  }
}
Messages.propTypes = propTypes;
const mapStateToProps = ({ messaging, user }) => ({
  messages: messaging.messages.toJS().list,
  conv: messaging.messages.toJS().conv,
  loadingMessages: messaging.messages.get('loadingMessages'),
  messagesLoaded: messaging.messages.get('messagesLoaded'),
  viewerCompany: user.toJS().company,
});
const mapDispatchToProps = dispatch => ({
  updateProps: (...args) => dispatch(updatePropsAction(...args)),
});
Messages.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Messages);



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/messages.jsx